var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSyncStroke = function SvgSyncStroke(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0002 16.3332C23.6771 16.3332 19.9001 18.6834 17.882 22.187C17.4383 22.9573 16.5954 23.4086 15.7083 23.3508C15.5297 23.3391 15.3491 23.3332 15.1668 23.3332C10.6565 23.3332 7.00016 26.9895 7.00016 31.4998C7.00016 36.0102 10.6565 39.6665 15.1668 39.6665C16.4555 39.6665 17.5002 40.7112 17.5002 41.9998C17.5002 43.2885 16.4555 44.3332 15.1668 44.3332C8.07918 44.3332 2.3335 38.5875 2.3335 31.4998C2.3335 24.6069 7.76779 18.9832 14.5858 18.6794C17.5335 14.4445 22.4412 11.6665 28.0002 11.6665C35.4045 11.6665 41.6549 16.5915 43.6599 23.3445C49.23 23.602 53.6668 28.1994 53.6668 33.8332C53.6668 39.6322 48.9658 44.3332 43.1668 44.3332C41.8782 44.3332 40.8335 43.2885 40.8335 41.9998C40.8335 40.7112 41.8782 39.6665 43.1668 39.6665C46.3885 39.6665 49.0002 37.0548 49.0002 33.8332C49.0002 30.6115 46.3885 27.9998 43.1668 27.9998C42.8377 27.9998 42.5166 28.0269 42.2052 28.0784C41.5924 28.1797 40.9645 28.0325 40.4606 27.6694C39.9566 27.3064 39.6183 26.7573 39.5204 26.144C38.6329 20.5832 33.8107 16.3332 28.0002 16.3332Z",
    fill: "#0258FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3337 27.9998C30.3337 26.7112 29.289 25.6665 28.0003 25.6665C26.7117 25.6665 25.667 26.7112 25.667 27.9998V41.9998C25.667 43.2885 26.7117 44.3332 28.0003 44.3332C29.289 44.3332 30.3337 43.2885 30.3337 41.9998V27.9998Z",
    fill: "#0258FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3504 24.0164C27.2616 23.1052 28.739 23.1052 29.6502 24.0164L36.6502 31.0164C37.5615 31.9276 37.5615 33.405 36.6502 34.3163C35.739 35.2275 34.2616 35.2275 33.3504 34.3163L28.0003 28.9662L22.6502 34.3163C21.739 35.2275 20.2616 35.2275 19.3504 34.3163C18.4392 33.405 18.4392 31.9276 19.3504 31.0164L26.3504 24.0164Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSyncStroke, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sync-stroke.c9863c0f.svg";
export { ForwardRef as ReactComponent };